import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

const state = {
  products: null,
  programs: null,
  speakers: null,
  loadingSpeakers: true,
  logos: null,
  loadingLogos: true,
  image: null,
  hotsite: null,
  hotsiteVersions: [],
  hotsiteSelectedVersion: null,
  loading: false,
  snackbar: {
    open: false,
    message: "",
    color: "white",
  },
  campaings: null,
  saveConfig: () => {},
  infos: null,
  infosCopy: null,
  tickets: null,
  sponsors: null,
  crmList: [],
  loadingCrm: false,
  faq: null,
  productErrorMessage: null,
  editViewType: 'desktop' // desktop or mobile
};

export default {
  state,
  actions,
  getters,
  mutations,
};
